<template>
  <div class="account">
    <a-modal :visible="visible" @cancel="visible = false" :title="title" width="460px" @ok="sub">
      <a-form-model ref="forms" :model="smlform" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
        <a-form-model-item :label="currentType == 'pattern' ? '代理模式名称' : '费用模式名称'">
          <a-input :placeholder="currentType == 'pattern' ? '请输入代理模式' : '请输入费用模式'" v-model="smlform.option_name">
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input placeholder="请输入序号" v-model="smlform.sort">
          </a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 代理人 -->
    <a-modal :visible="NewlyAdd" @cancel="NewlyAdd = false;" title="代理人" width="460px" @ok="subNewly">
      <a-form-model ref="forms" :rules="formrules" :model="AgentForm" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 17 }">
        <a-form-model-item label="代理模式" prop="agent_model_id">
          <a-select v-model="AgentForm.agent_model_id" placeholder="请选择代理模式">
            <a-select-option v-for="i in choiceOldList" :key="i.id" :value="i.id">{{ i.option_name
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="姓名" prop="name">
          <a-input placeholder="请输入姓名" v-model="AgentForm.name">
          </a-input>
        </a-form-model-item>
        <a-form-model-item :label="AgentForm.agent_model_id == 36 ? '证件号码' : '职业证号'" prop="certificate_number">
          <a-input :placeholder="AgentForm.agent_model_id == 36 ? '请填写证件号码' : '请填写职业证号'"
            v-model="AgentForm.certificate_number">
          </a-input>
        </a-form-model-item>
        <a-form-model-item :label="AgentForm.agent_model_id == 36 ? '工作单位' : '职业律所'" prop="workplace">
          <a-input :placeholder="AgentForm.agent_model_id == 36 ? '请输入工作单位' : '请输入职业律所'" v-model="AgentForm.workplace">
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="联系方式" prop="phone">
          <a-input placeholder="请输入联系方式" v-model="AgentForm.phone">
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-switch checked-children="启用" un-checked-children="禁用" default-checked v-model="AgentForm.status" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input placeholder="请输入序号" v-model="AgentForm.sort" style="width: 300px">
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-input placeholder="请输入备注" v-model="AgentForm.remark">
          </a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <div v-if="$common.AUTH('agency:index')">
      <div class="tcon wbg" v-if="$common.AUTH('agency:index')">
        <div style="display: flex;gap: 20px;">
          <div class="tconBox">
            <div>
              <div>
                <a-form-model ref="ruleForm" :model="forms1" class="group">
                  <div class="label">
                    代理模式：
                    <a-input v-model="forms1.option_name" placeholder="请输入代理模式" style="width: 167px">
                    </a-input>
                  </div>
                  <div class="allbtns">
                    <a-button icon="search" class="ant-btn" @click="queryModel()">查询</a-button>
                    <a-button style="min-width: 64px;" @click="reset('pattern')">重置</a-button>
                    <a-button icon="plus" @click="Add('pattern')" v-if="$common.AUTH('agency:add')">新增</a-button>
                  </div>
                </a-form-model>
              </div>
              <div class="tableList">
                <div class="ntable">
                  <table>
                    <thead>
                      <td width="40%">代理模式</td>
                      <td width="20%">排序</td>
                      <td width="40%">操作</td>
                    </thead>
                    <tbody>
                      <tr v-for="j in model_oldList" :key="j.id">
                        <td>{{ j.option_name }}</td>
                        <td>{{ j.sort }}</td>
                        <td>
                          <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="del(j.id, 'pattern')"
                            v-if="$common.AUTH('agency:delete')">
                            <a href="javascript:void(0);">删除</a>
                          </a-popconfirm>
                          <span class="line"></span>
                          <a href="javascript:void(0);" @click="
                            smlform = JSON.parse(JSON.stringify(j), currentType = 'pattern')
                          visible = true
                            " v-if="$common.AUTH('agency:edit')">修改</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="pages">
              <a-pagination v-model="forms1.page" :total="forms1.total" show-less-items show-quick-jumper :pageSize="20"
                @change="turnpage" :show-total="(total) => `小计 ${forms1.total}`" />
            </div>
          </div>
          <div class="tconBox">
            <div style="width: 100%;">
              <div>
                <a-form-model ref="ruleForm" :model="forms2" class="group">
                  <div class="label">
                    费用模式：
                    <a-input v-model="forms2.option_name" placeholder="请输入费用模式" style="width: 167px">
                    </a-input>
                  </div>
                  <div class="allbtns">
                    <a-button icon="search" class="ant-btn" @click="queryFeeAgency()">查询</a-button>
                    <a-button style="min-width: 64px;" @click="reset('cost')">重置</a-button>
                    <a-button icon="plus" @click="Add('cost')" v-if="$common.AUTH('agency:add')">新增</a-button>
                  </div>
                </a-form-model>
              </div>
              <div class="tableList">
                <div class="ntable">
                  <table>
                    <thead>
                      <td width="40%">费用模式</td>
                      <td width="20%">排序</td>
                      <td width="40%">操作</td>
                    </thead>
                    <tbody>
                      <tr v-for="j in hisCostAgencyList" :key="j.id">
                        <td>{{ j.option_name }}</td>
                        <td>{{ j.sort }}</td>
                        <td>
                          <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="del(j.id, 'cost')"
                            v-if="$common.AUTH('agency:delete')">
                            <a href="javascript:void(0);">删除</a>
                          </a-popconfirm>
                          <span class="line"></span>
                          <a href="javascript:void(0);" @click="
                            smlform = JSON.parse(JSON.stringify(j), currentType = '')
                          visible = true
                            " v-if="$common.AUTH('agency:edit')">修改</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="pages">
              <a-pagination v-model="forms2.page" :total="forms2.total" show-less-items show-quick-jumper :pageSize="20"
                @change="turnpage" :show-total="(total) => `小计 ${forms2.total}`" />
            </div>
          </div>
        </div>
      </div>
      <!-- 代理人 -->
      <div style="width: 100%;background-color: #fff;">
        <div class="tcon wbg" v-if="$common.AUTH('agency:index')">
          <div>
            <a-form-model ref="ruleForm" :model="forms" class="group">
              <div class="label">
                代理 人：
                <a-input v-model="forms.name" placeholder="请输入代理人" style="width: 167px">
                </a-input>
              </div>
              <div class="allbtns">
                <a-button icon="search" class="ant-btn" @click="queryAgent()">查询</a-button>
                <a-button style="min-width: 64px;" @click="resets">重置</a-button>
                <a-button icon="plus" @click="Newly" v-if="$common.AUTH('agency:add')">新增</a-button>
              </div>
            </a-form-model>
          </div>
          <div class="tableList">
            <div class="ntable">
              <table>
                <thead class="theadTd">
                  <td width="70">代理模式</td>
                  <td width="80">姓名</td>
                  <td width="100">证件号码/职业证号</td>
                  <td width="220">工作单位/职业律所</td>
                  <td width="90">联系方式</td>
                  <td width="60">状态</td>
                  <td width="40">排序</td>
                  <td width="180">备注</td>
                  <td width="90">操作</td>
                </thead>
                <tbody>
                  <tr v-for="(j, index) in agentList" :key="index" class="theadTd">
                    <td>{{ formedValue(j.agent_model_id) }}</td>
                    <td>{{ j.name }}</td>
                    <td>{{ j.certificate_number }}</td>
                    <td>
                      <Normap :tit="j.workplace"></Normap>
                    </td>
                    <td>{{ j.phone }}</td>
                    <td>
                      <a-badge :status="j.status == 0 ? 'error' : 'success'" />
                      {{ j.status | statusChange }}
                    </td>
                    <td>{{ j.id }}</td>
                    <td>
                      <Normap :tit="j.remark"></Normap>
                    </td>
                    <td>
                      <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="dels(j.id)"
                        v-if="$common.AUTH('agency:delete')">
                        <a href="javascript:void(0);">删除</a>
                      </a-popconfirm>
                      <span class="line"></span>
                      <a href="javascript:void(0);" @click="modify(j)" v-if="$common.AUTH('agency:edit')">修改</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="pages" style="width: 95%;">
            <a-pagination v-model="forms.page" :total="forms.total" show-less-items show-quick-jumper :pageSize="20"
              :show-total="(total) => `小计 ${total}`" />
          </div>
        </div>
      </div>
    </div>
    <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
  </div>
</template>
<script>
import {
  agencyAdd,
  agencyList,
  agencyEdit,
  agencyDel,
  by_type,
  by_typeAdd,
  by_typeEdit,
  by_typeDel,
  by_typeList,
  identityVerification
} from '@/server/directory'
import Validator from "@/assets/js/yz.js"

export default {
  data() {
    return {
      Validator,
      smlform: { option_name: '', sort: null },
      AgentForm: {
        name: '',
        workplace: '',//工作地点
        certificate_number: '',//证件号码
        phone: '',//联系方式
        agent_model_id: 36,//代理模式
        status: true,
        remark: '',//备注
        sort: '' //排序
      },
      forms: {
        name: '', type: 'agent_model', page: 1, limit: 20, option_name: '',
      },
      forms1: { option_name: '', type: 'agent_model', page: 1, limit: 20, option_name: '', },
      forms2: { option_name: '', type: 'cost_model', page: 1, limit: 20, option_name: '', },
      total: 0,
      model_oldList: [],
      agentList: [],//代理人信息
      hisCostAgencyList: [],//费用代理
      title: '',
      currentType: '',
      visible: false,
      NewlyAdd: false,
      choiceOldList: [],
      formrules: {
        name: [{ required: true, message: '请填写姓名', trigger: 'change' }],
        certificate_number: [{ required: true, trigger: 'blur', message: '请填写身份信息' }],
        phone: [{ required: true, message: '请填写联系方式', trigger: 'change' }],
        agent_model_id: [{ required: true, message: '请选择代理模式', trigger: 'change' }],
        workplace: [{ required: true, message: '请填写工作地点', trigger: 'change' }],
      }
    }
  },
  filters: {
    statusChange(val) {
      const tit = {
        1: '启用',
        0: '禁用',
      }
      return tit[val]
    },
  },
  created() {
    this.query()
  },
  computed: {
    formedValue() {
      return (val) => {
        const nameStatus = this.choiceOldList;
        const matchedOption = nameStatus.find(item =>
          item.id === Number(val) || item.id === val
        );
        return matchedOption ? matchedOption.option_name : val;
      };
    }
  },
  methods: {

    Newly() {
      const defaultForm = {
        name: '',
        workplace: '',
        certificate_number: '',
        phone: '',
        agent_model_id: 36,
        status: true,
        remark: '',
        sort: ''
      };
      this.AgentForm = defaultForm
      this.NewlyAdd = true
    },
    modify(j) {//修改代理人
      this.NewlyAdd = true
      this.AgentForm = { ...j }
      this.AgentForm.status = this.AgentForm.status == 1 ? true : false
    },
    Add(type) {
      this.visible = true
      this.currentType = type
      this.smlform.id = null
      this.smlform.sort = null
      this.smlform.option_name = null
      this.smlform.sort = null
      if (type == 'pattern') {
        this.title = '代理模式'
      } else if (type == 'cost') {
        this.title = '费用模式'
      }
    },
    turnpage(val) {
      // this.form.page = val
      this.query()
    },
    del(id, type) {
      if (type == 'pattern') {
        by_typeDel({ "id": id }).then((e) => {
          this.$message.success({ content: '删除成功' })
          this.queryModel()
        })
      } else {
        by_typeDel({ "id": id }).then((e) => {
          this.$message.success({ content: '删除成功' })
          this.queryFeeAgency()
        })
      }
    },
    dels(id) {//删除代理人
      agencyDel({ "id": id }).then((e) => {
        this.$message.success({ content: '删除成功' })
        this.queryAgent()
      })
    },
    sub() {
      if (this.currentType == 'pattern') {//代理模式

        if (this.smlform.id) {
          by_typeEdit(this.smlform).then((e) => {
            this.$message.success({ content: '修改成功' })
            this.visible = false
            this.queryModel()
          })
        } else {
          let smlform = {
            option_type: 'agent_model',
            option_name: this.smlform.option_name,
            sort: this.smlform.sort
          }
          by_typeAdd(smlform).then((e) => {
            this.$message.success({ content: '新增成功' })
            this.visible = false
            this.queryModel()
          })
        }
      } else {
        if (this.smlform.id) {//费用模式

          this.smlform.option_name = this.smlform.option_name
          by_typeEdit(this.smlform).then((e) => {
            this.$message.success({ content: '修改成功' })
            this.visible = false
            this.queryFeeAgency()
          })
        } else {
          let smlform = {
            option_type: 'cost_model',
            option_name: this.smlform.option_name,
            sort: this.smlform.sort
          }
          by_typeAdd(smlform).then((e) => {
            this.$message.success({ content: '新增成功' })
            this.visible = false
            this.queryFeeAgency()
          })
        }
      }

    },

    async subNewly() {
      let form = { ...this.AgentForm }
      form.status = form.status == true ? 1 : 0;
      const valid = await new Promise(resolve => {
        this.$refs.forms.validate(resolve)
      })
      if (!valid) return
      let needCheck = form.agent_model_id == 36
      let checkPass = true
      if (needCheck) {
        checkPass = await this.IdentityEvent(form)//身份验证接口
        if (!checkPass) return
      }
      if (form.id) {
        agencyEdit(form).then((e) => {
          this.$message.success({ content: '修改成功' })
          this.NewlyAdd = false
          this.queryAgent()
        })
      } else {
        agencyAdd(form).then((e) => {
          this.$message.success({ content: '新增成功' })
          this.NewlyAdd = false
          this.queryAgent()
        })
      }
    },
    async IdentityEvent(form) {
      const res = await identityVerification({
        type: 1,
        realname: form.name,
        chinaid: form.certificate_number
      })
      if (!res.check_result) {
        this.$message.warning({ content: '请填写正确的身份信息' })
        return false //失败
      }
      return true //正常
    },
    queryFeeAgency() {
      return by_typeList(this.forms2).then((res) => {
        this.hisCostAgencyList = res.list;
        this.forms2.total = res.count;
        return res;
      });
    },

    queryModel() {
      return by_typeList(this.forms1).then((res) => {
        this.model_oldList = res.list;
        this.forms1.total = res.count;
        return res;
      });
    },

    queryAgent() {
      return agencyList(this.forms).then((res) => {
        this.agentList = res.list;
        this.forms.total = res.count;
        return res;
      });
    },
    by_type() {
      return by_typeList(
        { type: 'agent_model' }
      ).then((res) => {
        this.choiceOldList = res.list;
        return res;
      });
    },
    query() {
      this.queryFeeAgency();
      this.queryModel();
      this.queryAgent();
      this.by_type()
    },
    reset(type) {
      if (type == 'pattern') {
        this.forms1.limit = 20
        this.forms1.page = 1
        this.forms1.option_name = ''
        this.queryModel()
      } else {
        this.forms2.limit = 20
        this.forms2.page = 1
        this.forms2.option_name = ''
        this.queryFeeAgency()
      }

    },
    resets() {
      this.forms.limit = 20
      this.forms.page = 1
      this.forms.name = ''
      this.queryAgent()
    }
  },
}
</script>
<style lang="less" scoped>
.account {
  @import url("@/assets/css/topForm");
}

.tcon {
  padding: 0 20px;
  min-height: 380px;

  .tableList {
    display: flex;
    justify-content: space-between;


    .ntable {
      flex: 1;
      margin-right: 20px;
      max-width: 100%;

      table {
        width: 100%;
      }

      thead {
        td {
          height: 36px;
          background: #f4f5f9;
          border: 1px solid #efefef;
          // padding-left: 60px;
          text-align: center;
        }
      }

      tbody {
        border-right: 1px solid #efefef;

        td {
          height: 54px;
          border-bottom: 1px solid #efefef;
          border-left: 1px solid #efefef;
          text-align: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 14px;
            background-color: #dbdcde;
            margin: 0 10px;
            vertical-align: middle;
          }
        }
      }

      &:nth-last-child(1) {
        margin: 0;
      }
    }
  }
}

.theadTd {
  td {
    padding-left: 0px !important;
    text-align: center;
  }
}

.pages {
  width: 95%;
  text-align: right;
}

.tconBox {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

}

.modal-footer {
  text-align: center;

  .cancel {
    background-color: #b2c9e1;
    border-color: #b2c9e1;
    margin-left: 30px;
  }
}

.group {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding: 20px 0;
  gap: 20px;
}

.allbtns {
  display: flex;

  button {
    margin-left: 20px;
    min-width: 90px;
    height: 32px;
  }
}
</style>
